import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "BQ-BO_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#BQ-BO_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 10.933V0h16L0 10.933z",
      fill: "#FEDA00"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 24h32.009V0L0 24z",
      fill: "#00268D"
    }
  ), /* @__PURE__ */ l.createElement("mask", { id: "BQ-BO_svg__b", fill: "#fff" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.353 5l.526 1.13a4.4 4.4 0 013.873 4.26l.955.477-1.044.522a4.404 4.404 0 01-3.742 3.474L9.353 16l-.569-1.137a4.404 4.404 0 01-3.741-3.475L4 10.866l.954-.477A4.4 4.4 0 018.79 6.135L9.353 5z"
    }
  )), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.353 5l.526 1.13a4.4 4.4 0 013.873 4.26l.955.477-1.044.522a4.404 4.404 0 01-3.742 3.474L9.353 16l-.569-1.137a4.404 4.404 0 01-3.741-3.475L4 10.866l.954-.477A4.4 4.4 0 018.79 6.135L9.353 5z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M9.88 6.13l-.719.335.186.4.439.052.093-.786zM9.352 5l.717-.334-.695-1.495-.732 1.477.71.352zm4.399 5.39l-.792.019.012.476.426.213.354-.709zm.955.477l.354.708 1.417-.708-1.417-.708-.354.708zm-1.044.522l-.354-.708-.344.172-.078.377.776.159zm-3.742 3.474l-.101-.785-.419.054-.188.377.708.354zM9.353 16l-.709.354.709 1.417.708-1.417L9.353 16zm-.569-1.137l.709-.354-.19-.377-.417-.054-.102.785zm-3.741-3.475l.776-.16-.078-.377-.344-.172-.354.709zM4 10.866l-.354-.708-1.417.708 1.417.709.354-.709zm.954-.477l.355.708.426-.213.011-.475-.792-.02zM8.79 6.135l.1.786.421-.054.189-.38-.71-.352zm1.807-.339l-.527-1.13-1.435.668.526 1.131 1.436-.669zm3.947 4.574a5.193 5.193 0 00-4.571-5.026l-.188 1.573a3.609 3.609 0 013.175 3.492l1.583-.039zm.517-.211l-.955-.478-.708 1.417.955.477.708-1.416zm-1.044 1.938l1.044-.521-.708-1.417-1.044.522.708 1.416zm-3.995 3.552a5.195 5.195 0 004.417-4.1l-1.552-.32a3.612 3.612 0 01-3.067 2.849l.202 1.57zm-.81-1.14l-.568 1.137 1.417.708.568-1.136-1.416-.709zm.849 1.137l-.568-1.137-1.417.708.568 1.137 1.417-.708zm-5.794-4.1a5.196 5.196 0 004.416 4.103l.203-1.571a3.612 3.612 0 01-3.067-2.85l-1.552.319zm-.621.029l1.043.521.708-1.417-1.043-.521-.708 1.417zM4.6 9.68l-.954.477.708 1.417.955-.478L4.6 9.681zM8.69 5.35a5.193 5.193 0 00-4.527 5.02l1.583.039A3.609 3.609 0 018.89 6.92l-.2-1.571zm-.047-.702L8.08 5.784l1.42.703.562-1.135-1.42-.704z",
      fill: "#000",
      mask: "url(#BQ-BO_svg__b)"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.376 8.3l-.649 1.089h-1.28l.639 1.144-.639 1.098h1.28l.65 1.12.658-1.12h1.269l-.623-1.098.623-1.144h-1.269l-.659-1.09z",
      fill: "#F00A17"
    }
  ))
);
export {
  a as default
};
